import { render, staticRenderFns } from "./AddAgentDialog.vue?vue&type=template&id=54d09dca"
import script from "./AddAgentDialog.vue?vue&type=script&lang=js"
export * from "./AddAgentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports